import { render, staticRenderFns } from "./shortcode.vue?vue&type=template&id=51429302&"
import script from "./shortcode.vue?vue&type=script&lang=js&"
export * from "./shortcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports